<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue & composables
// -------------------------------
import { computed } from 'vue';

// -------------------------------
// 🔹 Composants
// -------------------------------
import Dialog from 'primevue/dialog';
import CreateCommerceStepOne from '@/components/commerce/CreateCommerceStepOne.vue';
import CreateCategory from '@/components/category/createCategory.vue';

// -------------------------------
// 🔹 Stores
// -------------------------------
import { useDialogStore } from '@/store/dialog.store';

// -------------------------------
// 🔹 Utils & refs
// -------------------------------
import { globalHeaderTitleLayout } from '../refs/common.refs';
import UpdateCommerce from '@/components/commerce/updateCommerce.vue';
import UploadFile from '@/components/file/uploadFile.vue';
import UpdateFile from '@/components/file/updateFile.vue';
import ReadMoreModal from '@/components/commande/readMoreModal.vue';
import DeleteDialog from './DeleteDialog.vue';
import updateClient from '@/components/user/updateClient.vue';
import CreateTaxe from '@/components/taxe/createTaxe.vue';
import CreateCurrency from '@/components/currency/createCurrency.vue';
import ReadMoreProm from '@/components/promotion/readMoreProm.vue';
import CreateProm from '@/components/promotion/createProm.vue';
import CreateCommerceHorraire from '@/components/commerce/createCommerceHorraire.vue';
import CreateContact from '@/components/commerce/createContact.vue';
import CreateUser from '@/components/user/createUser.vue';
import UpdateUserInfos from '@/components/user/updateUserInfos.vue';
import UpdatePassword from '@/components/user/updatePassword.vue';
import AssignRole from '@/components/user/assignRole.vue';
import CreateSlugCommerce from '@/components/commerce/createSlugCommerce.vue';
import UpdateSlugCommerce from '@/components/commerce/updateSlugCommerce.vue';
import createImageOnboardCommerce from '@/components/commerce/createImageOnboardCommerce.vue';

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const dialogStore = useDialogStore();
// -------------------------------
// 🔹 Gestion du dialogue
// -------------------------------

/**
 * Ferme le dialogue et réinitialise les valeurs associées.
 */
const handleClose = (): void => {
  dialogStore.closeDialog();
};

/**
 * Supprime un commerce en utilisant l’ID stocké dans `idToDelete`.
 */

const pageMap: Record<string, any> = {
  isAddedFromCommerce: CreateCommerceStepOne,
  isUpdatedFromCommerce: UpdateCommerce,
  isAddedFromFile: UploadFile,
  isUpdatedFromFile: UpdateFile,
  isAddedFromCategoy: CreateCategory,
  isUpdatedFromClient: updateClient,
  isAddedFromTaxe: CreateTaxe,
  isAddedFromCurrency: CreateCurrency,
  isReadMoreFrom: ReadMoreProm,
  isAddedFromProm: CreateProm,
  isAddedFromCommerScheduled: CreateCommerceHorraire,
  isAddedFromCommerseContact: CreateContact,
  isAddedFromCreateUser: CreateUser,
  isUpdatedFromUser: UpdateUserInfos,
  isUpdatedFromUserPassword: UpdatePassword,
  isAddedFromAssignment: AssignRole,
  isAddedFromCommerceSlugs: CreateSlugCommerce,
  isUpdatedFromCommerceSlugs: UpdateSlugCommerce,
  isAddeddFromCommerceImageOnboadronSlugs: createImageOnboardCommerce,
};
const currentComponent = computed(() => {
  const content = dialogStore.content as any;
  if (!content) return null;

  for (const key in pageMap) {
    if (content[key] === true) {
      return pageMap[key];
    }
  }

  return null;
});

const handleOnCloseDialog = () => {};
</script>

<template>
  <template>
    <Dialog
      :header="globalHeaderTitleLayout"
      v-model:visible="dialogStore.visible"
      modal
      :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
      @hide="handleOnCloseDialog"
    >
      <div v-if="!currentComponent && !dialogStore.content?.isDeleted">
        <ReadMoreModal />
      </div>
      <div v-else-if="dialogStore.content?.isDeleted" class="h-[30vh]">
        <DeleteDialog />
      </div>
      <component :is="currentComponent" v-else @HandleClose="handleClose" />
    </Dialog>
  </template>
</template>
